import { render } from "./notice_music.vue?vue&type=template&id=11c12d50"
import script from "./notice_music.vue?vue&type=script&lang=js"
export * from "./notice_music.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__